import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M9.667 2.333h2a2 2 0 0 1 2 2v7.334a2 2 0 0 1-2 2h-2M10.333 8h-8m8 0L8 10.333M10.333 8 8 5.667"
	})
});
export default SvgExit;
